import React, { useEffect, useState } from "react";
import "./charts.css";
import { useSelector, useDispatch } from "react-redux";
import {
  createNewandGetTagEndPoint,
  addTagToDeviceEndPoint,
} from "../../../src/configuration";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../../src/global/axiosInterceptor";
import { transformPolygonData } from "../../global/utility/roiUtils";
import DisplayCanvas from "../../polygonLib/displayPolygonLib/displayCanvas";
import { Loader } from "@vds/loaders";
import { Body } from "@vds/typography";
import { TextLink, TextLinkCaret, Button } from "@vds/buttons";
import { Tooltip } from "@mui/material";

import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { TextLinkCaretButton } from "../Dashboard/styles";
import { Input } from "@vds/inputs";
import { ImageDownloadMedia } from "../../model/mediaService";
import {
  getWidgetLocationName,
  getWidgetLocationType,
} from "../../global/utility/widgetUtils";
import { fetchSnapshotImage, StreamType, fetchFovSnapshotImage } from "../../global/utility/snapshotService";
import { Icon } from "@vds/icons";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Title } from "@vds/typography";
import { Checkbox } from "@vds/checkboxes";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styled from "styled-components";
import { IconButton } from "@mui/material";
import { addNewSubArea, setAllTagList } from "../../../src/store/actions";
import TagsInput from "../../global/components/Tags/TagsInput";

import { extractNameFromFullWidgetName, setpathParam, deploymentstatusList, arrangeAsAlphabeticalOrderWithField } from "../../global/utility/statisticsUtil";
import { validateNameField, trimNameField } from "../EditSites/sitesUtil";
import { NAMING_VALIDATION_ERROR } from "../../global/constants/errorConstants";
import { red } from "@mui/material/colors";
import { adjustPolygonPoints } from "../../utils";
import { getActiveLicenseSku } from "../../global/constants/licensesConstants";

const StatDataSource = () => {
  const [viewingExpanded, setViewingExpanded] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const chartParam = state.chart;

  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const appName = state?.appName || "";
  const siteName = state?.siteName || "";
  const dispatch = useDispatch();

  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList);
  const filterlist = state?.filterlist || [];
  const siteReducerAllList = useSelector((state) => state.sitesReducer);
  const siteReducer = useSelector((state) => state.sitesReducer.siteTagList);
  const [sites, setSitesTagList] = useState(siteReducer?.sites || []);
    useEffect(() => {
      if (siteReducer?.sites) {
        setSitesTagList(arrangeAsAlphabeticalOrderWithField(siteReducer.sites, "name"));
      } else {
        setSitesTagList([]);
      }
    }, [siteReducer?.sites])

  const roiListItem = useSelector(
    (state) => state.polygonRoiReducer.roiListWithCvapps
  );
  const [isLoading, setIsLoading] = useState(true);

  const fovListItem = useSelector((state) => state.deviceReducer.fovList || []);
  const tagListItem = useSelector((state) => state.sitesReducer.tagIdList || []);
  const deviceListItem = useSelector((state) => state.deviceReducer.cameraList || []);
  const [filteredRoiList, setFilteredRoiList] = useState({});
  const uniqueTagsListArray = [];

  const reducerPairedImages = useSelector((state) => state.imagesReducer.streamImages);
  const reducerUnpairedImages = useSelector((state) => state.imagesReducer.unpairedImages);
  const reducerUnpairedCameraList = useSelector((state) => state.deviceReducer.discoveredCamerasList);



   const reduxStore = {
      activeSession,
      reducerPairedImages,
      reducerUnpairedImages,
      reducerStreamList : fovListItem,
      reducerUnpairedCameraList,
      dispatch
    };


  const AdditionalSubAreaFrame = styled.div`
    display: flex;
    align-items: center; // Center items vertically in the container
    gap: 10px;
    align-self: stretch;
    width: 100%;
    height: auto;
  `;

  const AddText = styled.h2`
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Verizon-NHG-eDS";
    font-size: 16px;
    font-style: normal;
    font-weight: ${(props) => (props.boldText ? 700 : 400)};
    line-height: 20px;
    letter-spacing: 0.5px;
    line-height: 1;
    margin: 0;
    vertical-align: middle;
    cursor: pointer;
  `;

  const sampleImage = "./assets/sample.png";
  const [baseLineDateTime, setBaseLineDateTime] = useState(
    state.baseLineDateTime
  );

  const handleCameraLink = (k) => {
    let filteredCameraList = deviceListItem.filter(
      (cam) => cam.name === getCameraName(k)
    );
    var camState = {};
    if (filteredCameraList.length > 0) {
      camState = {
        data: { ...filteredCameraList[0] },
        title: `More info for ${filteredCameraList[0].name}`,
        fields: filteredCameraList[0]?.fields || {},
      };
      navigate(`/cameraInfoPage?cameraId=${filteredCameraList[0].id}`);
    }
  };

  const handleCloseIconClickFromTopBar = () => {
    //handleCloseIconClickFromTopBar();
  };

  useEffect(() => {
    if (!roiListItem) {
      setIsLoading(true);
      return;
    }

    const baseAppName = appName.split("_")[0];
    const targetTags = state.subarea?.length ? state.subarea
      : state.area?.length ? state.area
      : state.floor?.length ? state.floor
      : state.site || [];
    const selectedTagIds = new Set(targetTags.map((t) => t.id));

    const { cvAppNames, cvAppImages } = cvAppList?.reduce(
      (acc, cvApp) => {
        if (cvApp?.resources?.displayName === baseAppName) {
          if (cvApp.name) acc.cvAppNames.add(cvApp.name);
          if (cvApp.image) acc.cvAppImages.add(cvApp.image);
        }
        return acc;
      },
      { cvAppNames: new Set(), cvAppImages: new Set() }
    ) || { cvAppNames: new Set(), cvAppImages: new Set() };

    const roisWithMatchingApp = roiListItem.filter(
      (item) =>
        Array.isArray(item?.cvapps) &&
        item.cvapps.length > 0 &&
        item.cvapps[0]?.resources?.displayName === baseAppName &&
        Array.isArray(item?.deployments) &&
        item.deployments.length > 0 &&
        deploymentstatusList.includes(item.deployments[0].status)
    );

    const filteredList = roisWithMatchingApp.filter((r) => {
      const hasMatchingName = cvAppNames.has(r.cvapps?.[0]?.name);
      const tagIds = r.customdata?.statisticstagids || r.tagids || [];
      return hasMatchingName && tagIds.some((id) => selectedTagIds.has(id));
    });

    const siteMap = new Map(sites?.map((s) => [s?.id, s?.name]));
    const result = filteredList.reduce((acc, roi) => {
      const hasMatchingImage = roi?.cvapps?.some((cvApp) => cvAppImages.has(cvApp.image));
      if (hasMatchingImage) {
        const tagSiteName = siteMap.get(roi?.siteids?.[0]) || "UnSubscribed";
        if (!acc[tagSiteName]) {
          acc[tagSiteName] = [];
        }
        acc[tagSiteName].push({ ...roi, tagSiteName });
      }
      return acc;
    }, {});

    /*  To filter the  roilist based on Parent side   
    on basis of site Selected  from Statistics page  */
    // if (siteName !== "All Site") {
    //   var obj = {};
    //   obj[siteName] = result[siteName];
    //   result = obj;
    // }

    if (Object.values(result)[0] === undefined) {
      setIsLoading(false);
    } else {
      getCameraSnapshot(result);
    }
  }, [roiListItem]);

  const getCameraName = (roi) => {
    var t = fovListItem.filter((m) => {
      return m?.id === roi?.parentdeviceid;
    })[0];
    var d = deviceListItem.filter((k) => {
      return k?.id === t?.parentdeviceid;
    })[0];
    return d?.name;
  };

  const handleRoiLink = (kObj) => {
    const fov = fovListItem.find((f) => f.id === kObj.parentdeviceid);
    if (!fov) return;
    const camera = deviceListItem.find((d) => d.id === fov.parentdeviceid);
    if (!camera) return;
    const fieldOfViews = fovListItem.filter((f) => f.parentdeviceid === camera.id);
    const fovName = fov?.customdata?.fovname ?? fov?.name ?? "";
    const cvApp = kObj.cvapps?.[0];
    const cvAppId = cvApp?.id;
    const cvAppName = cvApp?.resources?.displayName ?? cvApp?.name ?? "";

    // RoiList passes { polygon: customdata.polygon } as the `frame` arg to onClickOfIcon,
    // so frame.polygon.frame.maxX/maxY resolves to customdata.polygon.frame.maxX/maxY
    const frameObj = { polygon: kObj.customdata?.polygon };
    const polygonPoints = transformPolygonData(kObj.customdata);

    const maxX = frameObj?.polygon?.frame?.maxX ?? frameObj?.polygon?.polygon?.frame?.maxX;
    const maxY = frameObj?.polygon?.frame?.maxY ?? frameObj?.polygon?.polygon?.frame?.maxY;

   const polygonPointList =  adjustPolygonPoints([maxX, maxY], polygonPoints, [832, 532]);

    const fovObj = {
          "FOVId": fov?.id,
          "cameraId": camera.id,
          "category": cvApp?.category,
          "companionId": camera?.parentdeviceid,
          "cvappid": cvAppId,
          "deployments": kObj.deployments,
          "id": kObj.id,
          "polygon": kObj.customdata?.polygon,
          "roiName": kObj.name,
          "tagIds": kObj.tagids ?? []
        }

    const roiItem = {
      category: cvApp?.category,
      cvAppName: cvApp?.resources?.displayNameFull,
      cvappid: cvAppId,
      companionSelected:camera?.parentdeviceid,
      deployments: kObj.deployments,
      fovObj:fovObj,
      frame: fovObj,
      groupName: fovName,
      name: kObj.name,
      originalPoints: polygonPoints?.length >= 3 ? polygonPoints : [],
      points: polygonPointList,
      roiId: kObj.id,
      selectedCameraQR: camera.id
    };
    const locaNamesList = kObj?.customdata?.statisticstagids?.map(m => siteReducerAllList?.tagIdList?.find(k => k.id === m)?.name) ?? [];

    const cvappsItem = {
      title: fovName,
      value: cvApp?.resources?.displayNameFull,
      floorImage: "",
      cvappid: cvAppId,
      roiId: kObj.id,
      category: cvApp?.category,
      tagids: kObj.tagids ?? [],
      sitenames: locaNamesList,
      groupName: `ROI1-${fovName}-${cvAppName}`,
      deployments: kObj.deployments,
    };


    const selectedState = {
        cvapps: [cvappsItem],
        roiUpdateData: [roiItem],
        FOVId: kObj.parentdeviceid,
        cameraId: camera.id,
        companionId: camera.parentdeviceid,
        action: "update",
        cameraData: camera,
        streamData: [fov],
        FOVSnapshot: kObj.imageUrl,
        fieldOfViews: fieldOfViews,
        FOVName: fovName,
        location: "roilist",
        cameraname: camera?.name,
        cvappid: cvAppId,
        tagids: kObj.tagids ?? [],
        deployParameters: kObj.deployments?.[0]?.config?.["deploy-parameters"] ?? [],
        deploymentId: kObj.deployments?.[0]?.id ?? "",
        sku: getActiveLicenseSku(fov?.licenses),
        roiList: [roiItem],
        siteSelected: camera.siteids,
        originPage: "statDataSource",
        record: {},
      }
    

    navigate("/polygon", {
      state: selectedState,
    });
  };

  const getCameraSnapshot = async (result) => {
    await Promise.all(
      Object.keys(result).map(async (m) => {
        await Promise.all(
          result[m]
            ?.sort((a, b) =>
              String(getCameraName(a)).localeCompare(getCameraName(b))
            )
            .map(async (k) => {
              var t = fovListItem.find((fov) => {
                return fov?.id === k?.parentdeviceid;
              });
              if (t?.customdata?.imageid !== undefined) {
                try {
                  const r = await fetchFovSnapshotImage(t.id, t.parentdeviceid, StreamType.PAIRED_CAMERA, "", reduxStore, false);
                  const url = r?.imageUrl;
                  if (url) {
                    k.imageUrl = url;
                  } else {
                    const r2 = await fetchFovSnapshotImage(t.id, t.parentdeviceid, StreamType.PAIRED_CAMERA, "", reduxStore, true);
                    k.imageUrl = r2?.imageUrl;
                  }
                } catch (error) {
                  console.log("Unable to fetch camera snapshot");
                  k.imageUrl = "";
                }
              }
            })
        );
      })
    );

    setIsLoading(false);
    const finalResult = Object.keys(result).map((m, mIndex) => {
      let roiList = [];
      result[m].forEach((_roi, roiIndex) => {
        if (
          getCameraName(result[m][roiIndex]) ===
          getCameraName(result[m][roiIndex - 1])
        ) {
          roiList[roiList.length - 1].push(result[m][roiIndex]);
        } else {
          roiList.push([result[m][roiIndex]]);
        }
      });
      const siteName = Object.keys(result)[mIndex];
      return { siteName, roiList };
    });
    setFilteredRoiList(finalResult);
  };

  const handle_backToStatistics = () => {
    navigate(`/statistics?appName=${setpathParam(state?.appName)}`, {
      state: {
        tillDate: baseLineDateTime,
        appName: state?.appName,
        appNameId: state?.appName,
        siteName: state?.siteName,
        //siteId: state?.siteId,
        site: state?.site,
        floor: state?.floor,
        area: state?.area,
        subarea: state?.subarea,
        allFloors: state?.allFloors,
        allAreas: state?.allAreas,
        allSubAreas: state?.allSubAreas,
      },
    });
  };
  const [statisticOpen, setStatisticOpen] = useState(false);

  const [noZone, setNoZone] = useState("");
  const [roiCvappsImage, setRoiCvappsImage] = useState("");
  const [selectStatistic, setSelectStatistic] = useState([]);

  const [tags, setTags] = useState([]);
  const [selectedRoi, setSelectedRoi] = useState({});

  const [floorList, setFloorList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [subareaList, setSubareaList] = useState([]);

  const sitesTagList =
    useSelector((state) => {
      return state.sitesReducer.siteTagList;
    }) || JSON.parse(sessionStorage.getItem("SitesTagList"));

  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });

  const handleEditRoi = (roi) => {
    setStatisticOpen(false);
    const matchingListFloors = sitesTagList?.floors.filter((f) =>
      f?.tagids?.includes(state?.siteId)
    );
    const matchingListAreas = sitesTagList?.areas.filter(
      (e) =>
        matchingListFloors?.find((floor) => e.tagids?.includes(floor.id)) !==
        undefined
    );
    const matchingListSubAreas = sitesTagList?.subareas.filter(
      (e) =>
        matchingListAreas?.find((areas) => e.tagids?.includes(areas.id)) !==
        undefined
    );
    setRoiCvappsImage(roi.cvapps[0].image);
    setTags(roi?.tagids ? roi?.tagids : []);
    setSelectedRoi(roi);
    setFloorList(matchingListFloors);
    setAreaList(matchingListAreas);
    setSubareaList(matchingListSubAreas);
    setTimeout(() => {
      setStatisticOpen(true);
    }, 100);
  };

  const handleSelectedTags = (e, selectedid, name) => {
    const checked = e.target.checked;
    selectedid === "-1" && checked ? setNoZone("No Zone") : setNoZone("");
    if (checked) {
      if (!tags.includes(selectedid)) {
        setTags([...tags, selectedid]);
        selectStatistic.push(name);
        setSelectStatistic(selectStatistic);
      }
    } else {
      const removetagName = selectStatistic.filter((item) => item !== name);
      const removetagId = tags.filter((id) => id !== selectedid);
      setTags(removetagId);
      setSelectStatistic(removetagName);
    }
  };

  const addTagDevice = async (tagIds) => {
    try {
      const response = await axiosInstance.patch(addTagToDeviceEndPoint(), {
        accountname: activeSession.accountId,
        resourceidentifier: {
          deviceid: selectedRoi.id,
        },
        device: {
          tagids: tagIds,
        },
      });
      const res = response.data;
      return res;
    } catch (error) {
      console.error("Error creating resource:", error);
      return null;
    }
  };

  const handleSubmitStatistic = () => {
    addTagDevice(tags);
    setStatisticOpen(false);
  };

  const [subAreaValidationErrors, setSubAreaValidationErrors] = useState({});

  const handleSubAreaName = (e, subareas, areaId) => {
    const rawValue = e.target.value;
    subareas.name = rawValue;
    const errorKey = `${areaId}_new_subarea`;
    if (rawValue && !validateNameField(rawValue)) {
      setSubAreaValidationErrors(prev => ({ ...prev, [errorKey]: NAMING_VALIDATION_ERROR }));
    } else {
      setSubAreaValidationErrors(prev => {
        const { [errorKey]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleDeleteSubArea = (subareas, selectedareaid) => {
    const removematchingSubArea = subareaList?.filter(
      (subareas) =>
        (subareas.id !== null && subareas.tagids?.includes(selectedareaid)) ||
        !subareas.tagids?.includes(selectedareaid)
    );
    setSubareaList(removematchingSubArea);
  };

  const createNewSubAreaTag = async (payload) => {
    try {
      const response = await axiosInstance.post(
        createNewandGetTagEndPoint(),
        payload
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Error creating new sub area tag:", error);
      throw error;
    }
  };

  const handleNewSubArea = async (subarea, areaid) => {
    // Validate before creating
    if (!subarea.name || !validateNameField(subarea.name)) {
      return;
    }
    const payload = {
      accountname: activeSession.accountId,
      tags: [
        {
          kind: "ts.tag.subArea",
          name: trimNameField(subarea.name),
          tagids: [areaid],
        },
      ],
    };
    try {
      const response = await createNewSubAreaTag(payload);
      if (response && response.length > 0) {
        const newSubArea = response[0];
        const newSubareaList = subareaList?.filter(
          (subareas) =>
            (subareas.id !== null && subareas.tagids?.includes(areaid)) ||
            !subareas.tagids?.includes(areaid)
        );
        // creating new array and updating
        const tagData = [...(tagIdList || []), newSubArea];
        dispatch(setAllTagList(tagData));
        //passing only the single subarea, not the entire array
        dispatch(addNewSubArea(newSubArea));
        setSubareaList([...newSubareaList, newSubArea]);
        // Clear validation error after successful creation
        setSubAreaValidationErrors(prev => {
          const { [`${areaid}_new_subarea`]: removed, ...rest } = prev;
          return rest;
        });
      } else {
        console.error("Failed to create new sub area tag");
      }
    } catch (error) {
      console.error("Error creating new sub area tag:", error);
    }
  };

  const imageSize = {
    width: 214,
    height: 128,
  };

  const handlePolygon = (k) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginRight: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              backgroundColor: "#F6F6F6",
              width: "auto",
              height: "40px",
              margin: "2px",
              padding: "10px 18px",
            }}
          >
            <Tooltip
              placement="bottom"
              title={
                <div
                  style={{
                    width: "auto",
                    padding: "5px",
                    color: "black",
                    fontSize: "12px",
                    backgroundColor: "white",
                  }}
                >
                  <Body size="small" viewport="desktop">
                    {getCameraName(k[0])}
                  </Body>
                </div>
              }
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    border: "1px solid black",
                    "& .MuiTooltip-arrow": {
                      backgroundColor: "white",
                    },
                  },
                },
              }}
            >
              <sup
                style={{
                  lineHeight: "normal",
                  fontSize: "14px",
                  color: "#000000",
                  top: "0px",
                }}
              >
                <TextLink
                  type="standAlone"
                  size="large"
                  className="link"
                  data-testid="statDataSource_cameraNameTextLink"
                  onClick={() => handleCameraLink(k[0])}
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "220px",
                    display: "block",
                    borderBottomStyle: "none",
                    overflow: "hidden",
                    textDecoration: "underline",
                    marginLeft: 2,
                  }}
                >
                  {getCameraName(k[0])}
                </TextLink>
              </sup>
            </Tooltip>
          </div>
          <div className="roiListElementsStreamContainer">
            {k.map((kObj, index) => (
              <div key={kObj?.id || index} className="roiListElementsStreamContainerDivWrapper"
              >
                <div className="roiListElementsStreamContainer">
                  <Tooltip
                    placement="bottom"
                    title={
                      <div className="roiListElementsStreamContainerDivWrapperTolltipText">
                        <Body size="small" viewport="desktop">
                          {kObj.name}
                        </Body>
                      </div>
                    }
                    arrow
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "white",
                          border: "1px solid black",
                          "& .MuiTooltip-arrow": {
                            backgroundColor: "white",
                          },
                        },
                      },
                    }}
                  >
                    <sup style={{ top: "0px" }}>
                      <TextLink
                        type="standAlone"
                        size="large"
                        className="link"
                        data-testid="statDataSource_roiNameTextLink"
                        onClick={() => handleRoiLink(kObj)}
                        style={{
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: "220px",
                          display: "block",
                          borderBottomStyle: "none",
                          overflow: "hidden",
                          textDecoration: "underline",
                          marginLeft: 2,
                        }}
                      >
                        {kObj.name}
                      </TextLink>
                    </sup>
                  </Tooltip>
                  {" "}
                </div>
                <div className="roiListElementsStreamContainerDivWrapperStreamImage">
                  {kObj.imageUrl && <DisplayCanvas
                    videoSource={kObj.imageUrl}
                    imageSize={imageSize}
                    initialPolygons={transformPolygonData(kObj.customdata)}
                    originalSize={[kObj.customdata, kObj.customdata]}
                  />}
                  {!kObj.imageUrl && <div className="noImageDiv"
                     >Not able to fetch paired image <br></br>click on it to reload <Icon name="sync" 
                     onClick={() => fetchFovSnapshotImage(kObj.id, kObj.parentdeviceid, StreamType.PAIRED_CAMERA, "", reduxStore, true)}></Icon></div>}
                </div>

                <ul className="roiListElementsStreamContainerDivWrapperlocNameUL" >
                  {" "}
                  {kObj?.customdata?.statisticstagids !== undefined &&
                    kObj?.customdata?.statisticstagids.length > 0 &&
                    kObj?.customdata?.statisticstagids.map((k) => {
                      let newTag = {
                        id: k,
                        name: getWidgetLocationName(k, tagListItem),
                      }
                      if (!uniqueTagsListArray.some(tag => tag.id === k)) {
                            uniqueTagsListArray.push(newTag);
                        }
                      return kObj?.cvapps[0]?.subcategory === "Entry Exit" ? (
                        <li className="roiListElementsStreamContainerDivWrapperEElocList">
                          {" "}
                          {getWidgetLocationName(k, tagListItem)}
                        </li>
                      ) : (
                        kObj?.cvapps[0]?.subcategory !== "Entry Exit" && (
                          <li className="roiListElementsStreamContainerDivWrapperEElocList">
                            {" "}
                            {getWidgetLocationName(k, tagListItem)}
                          </li>
                        )
                      );
                    })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  if (isLoading) {
    return <Loader active={true} fullscreen={false}></Loader>;
  }
  return (
    <>
      <div style={{ display: "flex" }} className="roi-header-col">
        <div>
          <Breadcrumbs surface="light">
            <BreadcrumbItem>
              <Link
                data-testid="statisticsDataSource_statisticsLink"
                to="/statistics"
                className="breadcrums-item_link"
              >
                Statistics
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>Data Source</BreadcrumbItem>
          </Breadcrumbs>
          <h3
            className="sasp_vz-nhg-eds-font"
            style={{ fontWeight: "300", fontSize: "32px" }}
          >
            Statistics
          </h3>
        </div>
      </div>

      <div className="filterBarSection" style={{ zIndex: "2" }}>
        <div
          className="filterBarMainBackIcon"
        >
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="moreContainer"
              onClick={() => handle_backToStatistics()}
            >
              <div className="advancedSettingsWrapper">
                <Tooltip
                  placement="bottom"
                  title={
                    <div
                      style={{
                        width: "auto",
                        padding: "5px",
                        color: "black",
                        fontSize: "12px",
                        backgroundColor: "white",
                      }}
                    >
                      <Body viewport="desktop" size="small" bold={true}>
                        {" "}
                      </Body>
                      <Body size="small" viewport="desktop">
                        Back to Statistics
                      </Body>
                    </div>
                  }
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "white",
                        border: "1px solid black",
                        "& .MuiTooltip-arrow": {
                          backgroundColor: "white",
                        },
                      },
                    },
                  }}
                >
                  <sup style={{ top: "0px" }}>
                    {" "}
                    <Icon name="left-caret" color="#000000" size="medium" />{" "}
                  </sup>
                </Tooltip>
              </div>{" "}
            </div>
          </div>
        </div>
        <div className={`filterBarMain ${viewingExpanded ? 'viewing-expanded' : ''}`}>
          <div
            style={{
              color: "#6F7171",
              display: "flex",
              flexDirection: "row",
              margin: "15px 15px 0 15px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", marginRight: "10px" }}
              onClick={() => setViewingExpanded(!viewingExpanded)}>
                <b>Viewing data sources for :</b>
                 {viewingExpanded && (
                                <Icon
                                  name="close"
                                  style={{ marginLeft: "10px", cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setViewingExpanded(false);
                                  }}
                                />
                              )}
              </div>
              <div style={{ display: "flex", marginRight: "10px" }}>
                <TagsInput
                  TagList={filterlist}
                  SiteList={[state.site]}
                  handleCloseIconClickFromTag={handleCloseIconClickFromTopBar}
                ></TagsInput>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="roiBodySection">
        {filteredRoiList.length > 0 &&
          filteredRoiList.map((m, mIndex) => {
            return (
              <div className="roiSiteSection">
                <span className="roiSiteSectionSpan">
                  {filteredRoiList[mIndex].siteName}
                </span>
                <div
                  className="roiListElements" >
                  {filteredRoiList[mIndex].roiList !== undefined &&
                    filteredRoiList[mIndex].roiList.length > 0 &&
                    filteredRoiList[mIndex].roiList.map((k, index) => {
                      // if (k.imageUrl) {
                      return handlePolygon(k);
                      // }
                    })}
                </div>
              </div>
            );
          })}

        <Modal
          opened={statisticOpen}
          disableOutsideClick={true}
          ariaLabel="Testing Modal"
          hideCloseButton={true}
        >
          <Title size="large" bold primitive="h2" viewport="desktop">
            Edit data sources
          </Title>
          <ModalBody>
            <div style={{ padding: "20px 0 20px 0" }}>
              <Body size="large" viewport="desktop" primitive="h2">
                Choose the location(s) that this region of interest (ROI) will
                contribute to the {appName} of.
              </Body>
            </div>

            {floorList && floorList.length && (
              <div
                style={{
                  padding: "20px 0 20px 0",
                  overflow: "auto",
                  height: "300px",
                }}
              >
                {floorList?.map((floor) => (
                  <>
                    <div
                      style={{
                        margin: "0px 0 10px 8px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{ margin: "0px 0 10px 8px", display: "flex" }}
                      >
                        {roiCvappsImage === "PeopleCountEE" ? (
                          <label>
                            <Checkbox
                              name="default"
                              width="auto"
                              label={"  "}
                              selected={tags.includes(floor.id) ? true : false}
                              error={false}
                              disabled={noZone ? true : false}
                              data-testid="statDataSource_selectedTagsCheckbox"
                              onChange={(e) => {
                                handleSelectedTags(e, floor?.id, floor?.name);
                              }}
                            />
                          </label>
                        ) : (
                          ""
                        )}
                        <Input
                          type="text"
                          label={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.3rem",
                              }}
                            >
                              <div>Floor name</div>
                            </div>
                          }
                          value={floor?.name}
                        />
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid rgba(0,0,0,0.3)",
                          padding: "10px",
                        }}
                      >
                        {areaList &&
                          areaList.length &&
                          areaList
                            ?.filter((area) => {
                              return area?.tagids?.includes(floor.id);
                            })
                            .map((area) => (
                              <div
                                style={{
                                  margin: "0px 0 10px 8px",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    margin: "0px 0 10px 8px",
                                    display: "flex",
                                  }}
                                >
                                  <label>
                                    <Checkbox
                                      name="default"
                                      width="auto"
                                      label={"  "}
                                      selected={
                                        tags.includes(area?.id) ? true : false
                                      }
                                      disabled={noZone ? true : false}
                                      error={false}
                                      data-testid="statDataSource_areaNameCheckbox"
                                      onChange={(e) => {
                                        handleSelectedTags(
                                          e,
                                          area?.id,
                                          area?.name
                                        );
                                      }}
                                    />
                                  </label>
                                  <Input
                                    type="text"
                                    label={
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "0.3rem",
                                        }}
                                      >
                                        <div>Area name</div>
                                        <InfoOutlinedIcon
                                          fontSize="small"
                                          sx={{ cursor: "pointer" }}
                                        />
                                      </div>
                                    }
                                    value={area?.name}
                                  />
                                </div>
                                <div
                                  style={{
                                    borderLeft: "1px solid rgba(0,0,0,0.3)",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {subareaList &&
                                  subareaList.length !== 0 &&
                                  subareaList?.find(
                                    (subarea) =>
                                      subarea.tagids?.includes(area.id) &&
                                      subarea.id === null
                                  ) !== undefined ? (
                                    ""
                                  ) : (
                                    <div
                                      style={{
                                        margin: "20px 0 10px 26px",
                                        display: "flex",
                                      }}
                                    >
                                      <AdditionalSubAreaFrame
                                        data-testid="statDataSource_addSubAreaPlusIcon"
                                        onClick={() =>
                                          setSubareaList([
                                            {
                                              id: null,
                                              kind: "ts.tag.subArea",
                                              name: "",
                                              tagids: [area.id],
                                            },
                                            ...subareaList,
                                          ])
                                        }
                                      >
                                        <Icon
                                          name="plus"
                                          color="#000000"
                                          size="large"
                                          style={{ cursor: "pointer" }}
                                        />
                                        <AddText>Add sub-area</AddText>
                                      </AdditionalSubAreaFrame>{" "}
                                    </div>
                                  )}
                                  {subareaList
                                    ?.filter((subarea) => {
                                      return subarea?.tagids?.includes(area.id);
                                    })
                                    .map((subareas) => {
                                      return (
                                        <div
                                          style={{
                                            margin: "20px 0 10px 26px",
                                            display: "flex",
                                          }}
                                        >
                                          {subareas?.id !== null ? (
                                            <label>
                                              <Checkbox
                                                name="default"
                                                width="auto"
                                                label={"  "}
                                                selected={
                                                  tags.includes(subareas?.id)
                                                    ? true
                                                    : false
                                                }
                                                disabled={
                                                  subareas?.id === null &&
                                                  (noZone ? true : false)
                                                }
                                                error={false}
                                                data-testid="statDataSource_subAreaNameCheckbox"
                                                onChange={(e) => {
                                                  handleSelectedTags(
                                                    e,
                                                    subareas?.id,
                                                    subareas?.name
                                                  );
                                                }}
                                              />
                                            </label>
                                          ) : (
                                            ""
                                          )}

                                          {subareas?.id !== null ? (
                                            <Input
                                              type="text"
                                              label="Sub-area name"
                                              value={subareas?.name}
                                            />
                                          ) : (
                                            ""
                                          )}
                                          {subareas?.id === null ? (
                                            <Input
                                              type="text"
                                              label="New Sub-area"
                                              data-testid="statDataSource_subAreaNameInput"
                                              onChange={(e) => handleSubAreaName(e, subareas, area.id)}
                                              defaultValue={
                                                subareas?.name === ""
                                                  ? ""
                                                  : subareas?.name
                                              }
                                              error={!!subAreaValidationErrors[`${area.id}_new_subarea`]}
                                              errorText={subAreaValidationErrors[`${area.id}_new_subarea`] || " "}
                                            />
                                          ) : (
                                            ""
                                          )}
                                          {subareas?.id === null ? (
                                            <IconButton
                                              data-testid="statDataSource_addSubAreaPlusIcon"
                                              onClick={() => {
                                                handleNewSubArea(
                                                  subareas,
                                                  area.id
                                                );
                                              }}
                                              style={{
                                                cursor: subAreaValidationErrors[`${area.id}_new_subarea`] ? "not-allowed" : "pointer",
                                                top: "8px",
                                              }}
                                              disabled={!!subAreaValidationErrors[`${area.id}_new_subarea`]}
                                            >
                                              <Icon
                                                name="plus"
                                                color={subAreaValidationErrors[`${area.id}_new_subarea`] ? "#A7A7A7" : "#000000"}
                                                size="large"
                                              />
                                            </IconButton>
                                          ) : (
                                            ""
                                          )}
                                          {subareas?.id === null ? (
                                            <IconButton
                                              data-testid="statDataSource_deleteSubAreaTrashIcon"
                                              onClick={() => {
                                                handleDeleteSubArea(
                                                  subareas,
                                                  area.id
                                                );
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                top: "8px",
                                              }}
                                            >
                                              <Icon
                                                name="trash"
                                                color="#000000"
                                                size="large"
                                              />
                                            </IconButton>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            ))}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            )}
          </ModalBody>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              size="large"
              use="primary"
              width="100%"
              data-testid="statDataSource_submitStatisticSaveButton"
              onClick={() => {
                handleSubmitStatistic();
              }}
              disabled={!selectStatistic.length}
            >
              Save
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
};
export default StatDataSource;
